import {
  AdminSentNotificationDto,
  GovernorateDto,
  PaginateQuery,
  SendNotificationRequest,
  SendNotificationV3Request,
} from "../../interfaces";
import { Paginated } from "../../models";
import {
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_ERROR,
  SendNotificationAction,
  SendNotificationSuccessAction,
  SendNotificationErrorAction,
  SEND_NOTIFICATION_V3,
  SEND_NOTIFICATION_V3_ERROR,
  SEND_NOTIFICATION_V3_SUCCESS,
  SendNotificationV3Action,
  SendNotificationV3ErrorAction,
  SendNotificationV3SuccessAction,
  ResetSendNotificationV3Action,
  RESET_SEND_NOTIFICATION_V3,
  GetAdminSentNotificationsAction,
  GetAdminSentNotificationsErrorAction,
  GetAdminSentNotificationsSuccessAction,
  GET_ADMIN_SENT_NOTIFICATIONS,
  GET_ADMIN_SENT_NOTIFICATIONS_ERROR,
  GET_ADMIN_SENT_NOTIFICATIONS_SUCCESS,
  ResetSendNotificationAction,
  RESET_SEND_NOTIFICATION,
  DeleteNotificationConsentAction,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_CONSENT,
  DELETE_NOTIFICATION_ERROR,
  DELETE_NOTIFICATION_SUCCESS,
  DeleteNotificationAction,
  DeleteNotificationErrorAction,
  DeleteNotificationSuccessAction,
} from "./actionTypes";

//#region Get AdminSentNotifications

export const getAdminSentNotifications = (
  request: PaginateQuery,
  history: History
): GetAdminSentNotificationsAction => {
  return {
    type: GET_ADMIN_SENT_NOTIFICATIONS,
    payload: { request, history },
  };
};

export const getAdminSentNotificationsSuccess = (
  response: Paginated<AdminSentNotificationDto>
): GetAdminSentNotificationsSuccessAction => {
  return {
    type: GET_ADMIN_SENT_NOTIFICATIONS_SUCCESS,
    payload: response,
  };
};

export const getAdminSentNotificationsError = (
  error: any
): GetAdminSentNotificationsErrorAction => {
  return {
    type: GET_ADMIN_SENT_NOTIFICATIONS_ERROR,
    payload: error,
  };
};

//#endregion

//#region send notification
export const sendNotification = (
  request: SendNotificationRequest
): SendNotificationAction => {
  return {
    type: SEND_NOTIFICATION,
    payload: { request },
  };
};

export const sendNotificationSuccess = (): SendNotificationSuccessAction => {
  return {
    type: SEND_NOTIFICATION_SUCCESS,
    payload: null,
  };
};

export const sendNotificationError = (
  error: any
): SendNotificationErrorAction => {
  return {
    type: SEND_NOTIFICATION_ERROR,
    payload: error,
  };
};

export const resetSendNotification = (): ResetSendNotificationAction => {
  return {
    type: RESET_SEND_NOTIFICATION,
    payload: null,
  };
};

//#endregion

//#region send notification v3

export const sendNotificationV3 = (
  request: SendNotificationV3Request
): SendNotificationV3Action => {
  return {
    type: SEND_NOTIFICATION_V3,
    payload: { request },
  };
};

export const sendNotificationV3Success =
  (): SendNotificationV3SuccessAction => {
    return {
      type: SEND_NOTIFICATION_V3_SUCCESS,
      payload: null,
    };
  };

export const sendNotificationV3Error = (
  error: any
): SendNotificationV3ErrorAction => {
  return {
    type: SEND_NOTIFICATION_V3_ERROR,
    payload: error,
  };
};

export const resetSendNotificationV3 = (): ResetSendNotificationV3Action => {
  return {
    type: RESET_SEND_NOTIFICATION_V3,
    payload: null,
  };
};

//#endregion

//#region Delete Notification

export const deleteNotificationConsent = (
  id: string
): DeleteNotificationConsentAction => {
  return {
    type: DELETE_NOTIFICATION_CONSENT,
    payload: id,
  };
};

export const deleteNotification = (id: string): DeleteNotificationAction => {
  return {
    type: DELETE_NOTIFICATION,
    payload: { id },
  };
};

export const deleteNotificationSuccess =
  (): DeleteNotificationSuccessAction => {
    return {
      type: DELETE_NOTIFICATION_SUCCESS,
      payload: null,
    };
  };

export const deleteNotificationError = (
  error: any
): DeleteNotificationErrorAction => {
  return {
    type: DELETE_NOTIFICATION_ERROR,
    payload: error,
  };
};

//#endregion
